import * as React from 'react';
import PropTypes from "prop-types";
import Button from "../../components/Button";
import {Input, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import SelectPriceShow from "../../components/Application/SelectPriceShow";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";

function AppTableModal(props) {
  const { t } = useTranslation('app_table_modal');
  const tableRef = React.createRef();
  const [showPrice, setShowPrice] = React.useState(props.workshop.settingShowPrice);
  const TableComponent = props.tableComponent;
  const [modalOpen, setModalOpen] = React.useState(props.modalOpen);
  const toggleModalOpen = (e) => {
    if(e){
      e.preventDefault()
    }
    setModalOpen(!modalOpen)
  };
  const [selected, setSelected] = React.useState([]);
  const [selectedCount, setSelectedCount] = React.useState(0);
  const [closeAfterChoose, setCloseAfterChoose] = React.useState(false);
  const toggleCloseAfterChoose = () => setCloseAfterChoose(!closeAfterChoose);
  const [addCountAllAvailable, setAddCountAllAvailable] = React.useState(false);
  const toggleAddCountAllAvailable = () => setAddCountAllAvailable(!addCountAllAvailable);

  React.useEffect(() => {
    if(props.onModalClosed && !modalOpen){
      props.onModalClosed()
    }
  }, [modalOpen]);

  return (
    <div>
      { props.children && React.cloneElement( props.children, {
        onClick: () => {
          if(!props?.modalOpenValidation || props.modalOpenValidation() !== false){
            toggleModalOpen()
          }
        },
        className: `cursor-pointer ${props.children.props.className || ''}`
      } ) }
      {modalOpen && <Modal isOpen scrollable className="height-100vh" toggle={e => {
        if(!(e?.target?.tagName.toLowerCase() === 'input' && e?.target?.getAttribute('role') === 'table-input-search' && e?.key === 'Enter')){
          toggleModalOpen();
        }
      }} size={props.size}>
        <ModalHeader toggle={toggleModalOpen}>
          <div className="d-flex justify-content-between align-items-center">
            <span>{props.modalTitle ?? t('title')}</span>

            <div className="d-flex flex-row flex-nowrap justify-content-end">
              <div className="d-flex flex-row flex-nowrap align-items-center cursor-pointer ml-3 mr-5" style={{maxWidth: '134px'}}>
                <Input type={'checkbox'} onChange={toggleCloseAfterChoose} checked={closeAfterChoose} />
                <span style={{ fontSize: '13px', lineHeight: '12px' }} onClick={toggleCloseAfterChoose}>
                  <span className="d-none d-md-block">{t('close_after_choose')}</span>
                  <span className="d-md-none">{t('close_after_choose_short')}</span>
                </span>
              </div>

              {props.showAddCountAllAvailable && <div className="d-flex flex-row flex-nowrap align-items-center cursor-pointer mr-3" style={{maxWidth: '200px'}}>
                <Input type={'checkbox'} onChange={toggleAddCountAllAvailable} checked={addCountAllAvailable}/>
                <span style={{fontSize: '13px', lineHeight: '12px'}} onClick={toggleAddCountAllAvailable}>
                  <span className="d-none d-md-block">{t('add_count_all_available')}</span>
                  <span className="d-md-none">{t('add_count_all_available_short')}</span>
                </span>
              </div>}

              {props.showPriceSwitcher && <SelectPriceShow value={showPrice} onChange={showPrice => setShowPrice(showPrice)}/>}
            </div>
          </div>
        </ModalHeader>
        <hr className="my-0"/>
        <ModalBody>
          <TableComponent
            ref={tableRef}
            searchFocused={true}
            clickToSelect={props.clickToSelect}
            linked={props.linked}
            filtersQuery={props.filtersQuery}
            addButton={props.addButton}
            addButtonType={'modal'}
            showPrice={showPrice}
            modifyUriParams={false}
            onSelectedChange={selected => {
              setSelected(selected);
              setSelectedCount(selected.length);
            }}
            onChoose={chosen => {
              props.onAccept(
                [
                  chosen
                ],
                !closeAfterChoose,
                addCountAllAvailable,
              )

              if(!closeAfterChoose){
                toggleModalOpen();
              }
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" className="mb-0" onClick={toggleModalOpen}>{t('common:btn.close')}</Button>
          <Button
            disabled={selectedCount === 0}
            onClick={() => {
              props.onAccept(
                selected,
                !closeAfterChoose,
                addCountAllAvailable
              );

              if(!closeAfterChoose){
                toggleModalOpen();
              }

              tableRef.current.selectedChange([])
              setSelectedCount(0);
              setSelected([]);
            }}
          >
            <span>{t('btn_choose_selected')}</span>
            {selectedCount > 0 && <span className="ml-2">({selectedCount})</span>}
          </Button>
        </ModalFooter>
      </Modal>}
    </div>
  );
}

AppTableModal.defaultProps = {
  clickToSelect: false,
  showPriceSwitcher: false,
  showAddCountAllAvailable: false,
  size: 'xl',
  modalOpen: false,
  linked: false,
  filtersQuery: {},
  addButton: false,
};

AppTableModal.propTypes = {
  modalTitle: PropTypes.any,
  addButton: PropTypes.bool,
  linked: PropTypes.bool,
  clickToSelect: PropTypes.bool,
  onModalClosed: PropTypes.func,
  modalOpen: PropTypes.bool,
  size: PropTypes.string,
  showPriceSwitcher: PropTypes.bool,
  showAddCountAllAvailable: PropTypes.bool,
  children: PropTypes.object.isRequired,
  onAccept: PropTypes.func.isRequired,
  tableComponent: PropTypes.object.isRequired,
  filtersQuery: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    workshop: state.workshop,
  }
}

export default connect(mapStateToProps)(AppTableModal);
